// ── Mock data ──────────────────────────────────────────────────────────────

export const WORKSHOPS = [
  { id:1, name:'AutoCenter Premium', address:'Av. Paulista, 1200 – SP', distance:'1.2 km', rating:4.8, reviews:312, services:['Troca de Óleo','Revisão Completa','Alinhamento','Balanceamento'], icon:'🔧', badge:'Mais popular' },
  { id:2, name:'Pneucar Express',    address:'R. Augusta, 340 – SP',     distance:'2.8 km', rating:4.6, reviews:198, services:['Troca de Pneus','Balanceamento','Alinhamento'],                icon:'🛞', badge:null },
  { id:3, name:'MegaOff Mecânica',   address:'Av. Brasil, 890 – SP',     distance:'3.5 km', rating:4.7, reviews:445, services:['Troca de Óleo','Freios','Suspensão','Elétrica'],               icon:'⚙️', badge:'Top rated' },
  { id:4, name:'Top Car Service',    address:'R. das Flores, 55 – SP',   distance:'4.1 km', rating:4.9, reviews:521, services:['Revisão Completa','Ar-Condicionado','Injeção Eletrônica'],     icon:'🏎️', badge:'Novo' },
  { id:5, name:'Freio & Cia',        address:'R. dos Pinheiros, 220 – SP',distance:'5.0 km', rating:4.5, reviews:134, services:['Freios','Suspensão','Alinhamento'],                            icon:'🛑', badge:null },
  { id:6, name:'ClimaCar AC Center', address:'Av. Santo Amaro, 610 – SP', distance:'6.3 km', rating:4.7, reviews:89,  services:['Ar-Condicionado','Elétrica','Injeção Eletrônica'],              icon:'❄️', badge:null },
];

export const SERVICES = [
  { id:1,  name:'Troca de Óleo',        icon:'🛢️', basePrice:120, category:'Revisão' },
  { id:2,  name:'Revisão Completa',     icon:'🔍', basePrice:350, category:'Revisão' },
  { id:3,  name:'Troca de Pneus',       icon:'🛞', basePrice:280, category:'Pneus' },
  { id:4,  name:'Alinhamento',          icon:'📐', basePrice:90,  category:'Pneus' },
  { id:5,  name:'Balanceamento',        icon:'⚖️', basePrice:70,  category:'Pneus' },
  { id:6,  name:'Freios',               icon:'🛑', basePrice:180, category:'Segurança' },
  { id:7,  name:'Suspensão',            icon:'🔩', basePrice:250, category:'Segurança' },
  { id:8,  name:'Ar-Condicionado',      icon:'❄️', basePrice:200, category:'Conforto' },
  { id:9,  name:'Injeção Eletrônica',   icon:'💻', basePrice:160, category:'Motor' },
  { id:10, name:'Elétrica',             icon:'⚡', basePrice:140, category:'Motor' },
];

export const TIME_SLOTS = ['08:00','09:00','10:00','11:00','13:00','14:00','15:00','16:00','17:00'];

// ── Score logic ────────────────────────────────────────────────────────────

export function calcScore({ rides, rating, years }) {
  const rideScore   = Math.min(rides / 5000, 1) * 40;
  const ratingScore = rating > 0 ? Math.max(0, ((rating - 3.5) / 1.5)) * 35 : 0;
  const yearsScore  = Math.min(years / 5, 1) * 25;
  return Math.round(rideScore + ratingScore + yearsScore);
}

export function calcDiscount(score) {
  if (score >= 90) return 25;
  if (score >= 75) return 20;
  if (score >= 55) return 15;
  if (score >= 35) return 10;
  return 5;
}

export function scoreLevel(score) {
  if (score >= 90) return { label:'Elite',     color:'#FFD700', next: null,        nextAt: null };
  if (score >= 75) return { label:'Ouro',      color:'#FFA500', next:'Elite',      nextAt: 90 };
  if (score >= 55) return { label:'Prata',     color:'#C0C0C0', next:'Ouro',       nextAt: 75 };
  if (score >= 35) return { label:'Bronze',    color:'#CD7F32', next:'Prata',      nextAt: 55 };
  return                   { label:'Iniciante', color:'#6B7280', next:'Bronze',     nextAt: 35 };
}

// ── Funnel content ─────────────────────────────────────────────────────────

export const PAIN_POINTS = [
  {
    icon: 'dollar-sign',
    title: 'Preço abusivo',
    desc: 'Você já pagou caro demais numa oficina porque não tinha tempo de pesquisar e comparar?',
  },
  {
    icon: 'shield-x',
    title: 'Sem confiança',
    desc: 'Já levou o carro numa oficina e sentiu que fizeram serviços desnecessários só pra inflar a conta?',
  },
  {
    icon: 'clock',
    title: 'Carro parado, lucro perdido',
    desc: 'Cada dia com o carro na oficina é um dia sem rodar, sem corrida — sem faturar nada.',
  },
  {
    icon: 'frown',
    title: 'Sem reconhecimento',
    desc: 'Você roda milhares de corridas por mês com nota 5 e nenhuma oficina te oferece desconto por isso?',
  },
];

export const TESTIMONIALS = [
  {
    name: 'Carlos M.',
    initials: 'CM',
    role: 'Uber · Score 82',
    level: 'Ouro',
    levelColor: '#FFA500',
    discount: '20%',
    text: 'Economizei R$ 340 em 3 meses só com manutenção. Hoje só faço serviço pela AutoFácil — não tem como voltar atrás.',
    metric: 'R$ 340 economizados',
  },
  {
    name: 'Ana P.',
    initials: 'AP',
    role: '99 · Score 67',
    level: 'Prata',
    levelColor: '#C0C0C0',
    discount: '15%',
    text: 'A oficina que encontrei aqui cobra metade do que eu pagava antes, e o serviço é melhor. Mudou minha rotina.',
    metric: '50% mais barato',
  },
  {
    name: 'João R.',
    initials: 'JR',
    role: 'Uber + 99 · Score 93',
    level: 'Elite',
    levelColor: '#FFD700',
    discount: '25%',
    text: 'Conectei os dois apps e bati Elite. 25% OFF em qualquer serviço. Compensa demais rodar bastante.',
    metric: '25% OFF garantido',
  },
];

export const SOCIAL_METRICS = [
  { value: 'R$ 2.4M', label: 'economizados pela comunidade' },
  { value: '48.000+', label: 'agendamentos realizados' },
  { value: '4.8 / 5', label: 'avaliação média das oficinas' },
  { value: '98%',     label: 'motoristas voltam a usar' },
];

export const FAQS = [
  {
    q: 'É de graça mesmo? Qual é o truque?',
    a: 'Sim, para o motorista é 100% gratuito. As oficinas pagam uma pequena taxa para estar na plataforma — como em um marketplace. Você nunca paga nada a mais por usar a AutoFácil.',
  },
  {
    q: 'E se a oficina fizer um serviço ruim?',
    a: 'Todas as oficinas são credenciadas e avaliadas após cada serviço. Se a nota cair abaixo de 4.0, a oficina é descredenciada automaticamente. Sua avaliação tem peso real.',
  },
  {
    q: 'Preciso ter muitas corridas para ter desconto?',
    a: 'Não! Todo motorista começa com 5% de desconto no nível Iniciante, sem mínimo de corridas. Conforme você roda mais e mantém boa avaliação, o desconto sobe automaticamente até 25%.',
  },
  {
    q: 'Meus dados ficam seguros?',
    a: 'Sim. Acessamos apenas dados públicos do seu perfil de motorista (corridas, nota, tempo ativo). Nunca temos acesso a dados de passageiros, rotas ou ganhos. Tudo conforme a LGPD.',
  },
  {
    q: 'Funciona na minha cidade?',
    a: 'Estamos começando por São Paulo, com expansão para Rio, BH e Curitiba nos próximos meses. Cadastre-se e te avisamos assim que chegarmos na sua região.',
  },
  {
    q: 'E se eu usar mais de um app?',
    a: 'Melhor ainda! Conecte Uber E 99 e seu score combina os dados dos dois — mais corridas = score mais alto = desconto maior. Sem complicação.',
  },
];

export const JOURNEY_STEPS = [
  {
    n: '01',
    icon: 'compass',
    title: 'Descoberta',
    awareness: 'Nível 1 → 2',
    desc: 'Você ouve sobre a AutoFácil por um colega ou anúncio e percebe que existe um problema na sua manutenção.',
  },
  {
    n: '02',
    icon: 'eye',
    title: 'Reconhecimento',
    awareness: 'Nível 2 → 3',
    desc: 'Lê as dores que apresentamos e pensa: "é exatamente isso que eu passo todo mês".',
  },
  {
    n: '03',
    icon: 'sparkles',
    title: 'Consideração',
    awareness: 'Nível 3 → 4',
    desc: 'Entende como o score vira desconto, vê depoimentos reais e percebe que a solução faz sentido pra você.',
  },
  {
    n: '04',
    icon: 'shield-check',
    title: 'Decisão',
    awareness: 'Nível 4 → 5',
    desc: 'Lê o FAQ, tira as últimas dúvidas e compara com a alternativa de continuar pagando caro.',
  },
  {
    n: '05',
    icon: 'rocket',
    title: 'Conversão',
    awareness: 'Pronto para agir',
    desc: 'Cria a conta grátis, conecta Uber ou 99 e vê seu desconto em 10 segundos. Agenda o primeiro serviço.',
  },
];

